module.exports = __webpack_public_path__ + "04_glasses_brown.19d865ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/04_glasses_brown.png
// module id = fZ7G
// module chunks = 0